<form role="form" [formGroup]="subjectForm">
<h1 mat-dialog-title>SUBJECT</h1>
<div mat-dialog-content>
  <p>{{data.title}}</p>
  
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Name of Subject</mat-label>
      <input matInput formControlName="name" placeholder="Enter name of subject">
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" placeholder="Enter a description of this subject">
    </mat-form-field>
  </p>
  
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
  <button mat-button [mat-dialog-close]="" cdkFocusInitial (click)="addSubject()">Save</button>
</div>
</form>
